import { useMemo } from "react";

import useListAllDestinationsForEnv from "@/destinations/v2/hooks/useListAllDestinationsForEnv";
import { LoadedDestinationInfo } from "../types/global";

export const useArrayOfDestinationsBySlug = (
  slug: string,
): Array<LoadedDestinationInfo> => {
  const { data } = useListAllDestinationsForEnv();

  return useMemo(
    () =>
      (data?.destinations ?? []).filter(
        (destination) => destination.type_slug === slug,
      ),
    [data?.destinations, slug],
  );
};

export default function useArrayOfDestinations(): Array<LoadedDestinationInfo> {
  const { data } = useListAllDestinationsForEnv();

  return useMemo(() => data?.destinations ?? [], [data?.destinations]);
}
